module.exports = __webpack_public_path__ + "static/zigzag-image3-2cd4b6ebb35000efffa22d463d3eaea9.png";